// extracted by mini-css-extract-plugin
module.exports = {"container":"DownloadiOS_container__3xGQy","ul":"DownloadiOS_ul__2a73J","svg":"DownloadiOS_svg__3LQ8B","svg_icon":"DownloadiOS_svg_icon__2sA8x","icon":"DownloadiOS_icon__16-7Y"};